module.exports = __webpack_public_path__ + "static/image/logo-family/logo_cartoon.png?4eb39054";